import React, { useContext, useState } from "react";

import DataProvider, {
    DataContext,
} from "../../../../../providers/PelletsDataProvider";
import pushToAnalytics from "../../../../../utils/analytics";
import { storageLocal as storage } from "../../../../../utils/StorageHandler";
import { AmountInput } from "../../../../pages/Pellets/CalculatorPage/Calculator";
import ProductSelect from "../../../../pages/Pellets/CalculatorPage/Calculator/ProductSelect";
import ZipcodeInput from "../../../../pages/Pellets/CalculatorPage/Calculator/ZipcodeInput";
import Button from "../../../NewForms/Button";
import { useNavigate } from "../provider";
import {
    ActionRow,
    FormContainer,
    FormRow,
    InputWrapper,
} from "../styledComponents";

const PelletsCalculator = () => {
    const dataContext = useContext(DataContext);
    const {
        zipcodeError,
        amountError,
        productError,
        zipcode,
        product,
        amount,
    } = dataContext.data;
    const { setZipcodeError, setAmountError } = dataContext.actions;

    const [localZipcode, setLocalZipcode] = useState(zipcode);
    const [localProduct, setLocalProduct] = useState(product);
    const [localAmount, setLocalAmount] = useState(amount);

    const onChangeAmount = (event) => {
        setLocalAmount(event.target.value);
    };

    const navigate = useNavigate("/holzpellets");

    const handleClick = () => {
        if (
            localZipcode &&
            !zipcodeError &&
            localAmount &&
            !amountError &&
            localProduct &&
            !productError
        ) {
            storage.set("pel:zipcode", localZipcode);
            storage.set("pel:product-type", localProduct);
            storage.set("pel:amount", localAmount);
            pushToAnalytics("pel:calculate", {
                zipcode: localZipcode,
                productType: localProduct,
                amount: localAmount,
                dataGtag: "pel-calculate-default",
            });
            setTimeout(() => navigate(), 0);
        }
    };

    return (
        <FormContainer>
            <FormRow>
                <InputWrapper>
                    <ZipcodeInput
                        setLocalZipcode={setLocalZipcode}
                        localProduct={localProduct}
                        localZipcode={localZipcode}
                        setZipcodeError={setZipcodeError}
                    />
                </InputWrapper>
                <InputWrapper>
                    <ProductSelect
                        localProduct={localProduct}
                        setLocalAmount={setLocalAmount}
                        setLocalProduct={setLocalProduct}
                    />
                </InputWrapper>
                <InputWrapper>
                    <AmountInput
                        product={localProduct}
                        amount={localAmount}
                        onChange={onChangeAmount}
                        onError={() => setAmountError(true)}
                        onErrorSolved={() => {
                            setAmountError(false);
                        }}
                    />
                </InputWrapper>
            </FormRow>
            <ActionRow>
                <Button onClick={handleClick} data-gtag="pel-calculate-default">
                    Preis berechnen
                </Button>
            </ActionRow>
        </FormContainer>
    );
};

const WithProvider = () => {
    return (
        <DataProvider>
            <PelletsCalculator />
        </DataProvider>
    );
};

export default WithProvider;
